export interface AppConfig {
    apiUrl: string;
    loginServerUrl: string;
    loginClientId: string;
    logoutServerUrl: string;
}

function loadAppConfig(): Promise<AppConfig> {
    return fetch("/config.json").then(response => response.json());
}

export const config: Promise<AppConfig> = loadAppConfig();
